// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6BZiP","answerBtn":"styles_answerBtn__JyuIX","active":"styles_active__PDIK2"};